import _ from 'lodash'

export function normalizeImovelFilterValue (value) {
  if (value === null || value === undefined || value === '' || value === 'all') {
    return null
  }

  return String(value)
}

export function normalizeSearchText (value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
}

export function includesNormalizedText (text, query) {
  const normalizedText = normalizeSearchText(text)
  const normalizedQuery = normalizeSearchText(query)

  return normalizedText.indexOf(normalizedQuery) > -1
}

export function buildRelatorioPagamentosPayload ({
  periodo = 'mes',
  filtros = {},
  dataInicial = null,
  dataFinal = null,
  status = [],
  imovelId = null
} = {}) {
  const payload = {
    periodo
  }

  if (!_.isEmpty(filtros)) {
    Object.assign(payload, filtros)
  }

  if (periodo === 'custom') {
    payload.data_inicial = dataInicial
    payload.data_final = dataFinal
  }

  if (_.isArray(status) && status.length > 0) {
    payload.status = status
  }

  const normalizedImovelId = normalizeImovelFilterValue(imovelId)
  if (normalizedImovelId) {
    payload.imovel_id = normalizedImovelId
  }

  return payload
}



// WEBPACK FOOTER //
// ./src/utils/relatoriosPagamentos.js